<template>
  <v-app id="app" class="mk-app">
    <v-app-bar color="primary" class="mk-toolbar">
      <div class="mk-toolbar-phone">
        <v-app-bar-nav-icon @click.stop="menuVisible = !menuVisible" />
        <div class="mk-toolbar-justify outline">
          Melina & Konstantin
        </div>
      </div>
      <div class="mk-toolbar-justify mk-toolbar-desktop">
        <router-link to="/">
          <v-btn text>Home</v-btn>
        </router-link>
        <a href="/gallery">
          <v-btn text>Bildergalerie <v-icon>open_in_new</v-icon></v-btn>
        </a>
        <router-link to="/ourStory">
          <v-btn text>Unsere Geschichte</v-btn>
        </router-link>
        <router-link to="/guestbook">
          <v-btn text>Gästebuch</v-btn>
        </router-link>
        <router-link to="/contact">
          <v-btn text>Kontakt</v-btn>
        </router-link>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="menuVisible" absolute temporary>
      <v-app-bar color="primary">Hochzeit Melina & Konstantin </v-app-bar>
      <v-list-item-group v-model="group">
        <router-link to="/" tag="div">
          <v-list-item>
            <v-icon>home</v-icon>
            <span>Home</span>
          </v-list-item>
        </router-link>
        <a href="/gallery" class="mk-menu-link">
          <v-list-item>
            <v-icon>camera_alt</v-icon>
            <span>Bildergalerie</span>
            <v-icon>open_in_new</v-icon>
          </v-list-item>
        </a>
        <router-link to="/ourStory" tag="div">
          <v-list-item>
            <v-icon>local_library</v-icon>
            <span>Unsere Geschichte</span>
          </v-list-item>
        </router-link>
        <router-link to="/guestbook" tag="div">
          <v-list-item>
            <v-icon>comment</v-icon>
            <span>Gästebuch</span>
          </v-list-item>
        </router-link>
        <router-link to="/contact" tag="div">
          <v-list-item>
            <v-icon>home</v-icon>
            <span>Kontaktdaten</span>
          </v-list-item>
        </router-link>
      </v-list-item-group>
    </v-navigation-drawer>

    <v-content class="mk-content">
      <div class="mk-content-background">
        <router-view />
      </div>
    </v-content>
  </v-app>
</template>

<style>
html,
body {
  height: 100%;
  width: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

.mk-app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.mk-toolbar {
  /* fix for IE11 */
  min-height: 64px;
  flex-grow: 0 !important;
}
.mk-menu-link {
  text-decoration: none;
}
.mk-toolbar-phone {
  display: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.mk-toolbar-justify {
  overflow: hidden;
  flex-grow: 100;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  flex-wrap: nowrap;
  justify-content: center;
}
@media only screen and (max-width: 720px) {
  .mk-toolbar-desktop {
    display: none;
  }
  .mk-toolbar-phone {
    display: flex;
  }
}

@media only screen and (orientation: portrait) {
  .mk-content-background {
    background-size: contain;
  }
}

@media only screen and (orientation: landscape) {
  .mk-content-background {
    background-size: cover;
  }
}

.mk-content {
  flex-grow: 1;
  width: 100%;
}
.mk-content-background {
  min-height: 100%;
  background-image: url("only-picture-1984x1417.jpg");
  background-position-x: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  display: flex;
}
</style>

<script>
export default {
  name: "app",
  data: () => ({
    menuVisible: false,
    group: null
  }),
  watch: {
    group() {
      this.menuVisible = false;
    }
  }
};
</script>
